import { createContext } from 'react';

const BankAccountsContext = createContext();

export default BankAccountsContext; 